export default "__VITE_ASSET__12bf9c13__"